import { render, staticRenderFns } from "./SettingsTournamentAmmount.vue?vue&type=template&id=6837b00c&"
import script from "./SettingsTournamentAmmount.vue?vue&type=script&lang=js&"
export * from "./SettingsTournamentAmmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports